export default () => ({
  sideBarOpen: false,
  sideBarTitle: "",
  sideBarSubtitle: "",
  sideBarComponent: null,
  sideBarData: null,
});
